import * as components from './components';

export default [
  {
    path: '/equipment',
    component: components.EquipmentList,
    name: 'equipmentList',
    meta: { admin: true }
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/equipment/routes.js